import { useQuery } from "@tanstack/react-query";
import { getExistingCitations } from "../api/existing-citations";
import { useAuth } from "@clerk/clerk-react";

export const useGetExistingCitations = () => {
  const { getToken } = useAuth();

  const {
    data: citations,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ["existing-citations"],
    queryFn: () => getExistingCitations({ getToken }),
    enabled: true,
  });

  return { citations, isLoading, refetch };
};
